import React from "react";
import logger from "../utils/logger";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("Unhandled app error:", error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="min-h-screen bg-gray-950 text-white flex items-center justify-center px-4">
        <section className="max-w-md w-full rounded-lg border border-gray-800 bg-gray-900 p-6 text-center shadow-xl">
          <h1 className="text-2xl font-semibold mb-3">Something went wrong</h1>
          <p className="text-gray-300 mb-6">
            The planner could not finish loading. Refresh the page to start a
            clean session.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="w-full rounded-md bg-blue-600 px-4 py-3 font-medium text-white hover:bg-blue-700 transition-colors"
          >
            Refresh Page
          </button>
        </section>
      </main>
    );
  }
}

export default ErrorBoundary;
